// extracted by mini-css-extract-plugin
export default {"container":"kjFKRgaHEtsvX1_R_mqS","label":"NTjGAku_cSqkd9O2pwH_","description":"yWVMCrYllwZwC8OeD2E_","termsContainer":"LPYqWXwhsjj9Y967rsg0","pulse":"QsAkEPBl12A3QOvt7qmZ"};